module.exports = __webpack_public_path__ + "static/img/dashboard-studio-visits.714f39b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doom-yoga/dashboard-studio-visits.png
// module id = vraT
// module chunks = 0